module.exports = __webpack_public_path__ + "img/zorgmanagement.11c159a9.svg";